import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => {
  return (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.998 3.95H6a1 1 0 0 0 -1.001 1v11.998a1 1 0 0 0 1 1.001h11.998a1 1 0 0 0 1 -1.001V4.95a1 1 0 0 0 -1 -1m-1.999 16v-0.004H7.998v1a1 1 0 1 1 -1.998 0v-1a3 3 0 0 1 -3 -3V4.95a3 3 0 0 1 3 -3h11.998a3 3 0 0 1 2.998 3v11.998a3 3 0 0 1 -3 3v1a1 1 0 1 1 -1.998 0zM10.998 9.948a1.001 1.001 0 1 0 0 1.999 1.001 1.001 0 0 0 0 -1.999m-3 1a3 3 0 0 1 5.828 -1h1.17a1 1 0 1 1 0 1.999h-1.17a3 3 0 0 1 -5.828 -1.001"
        fill={fill}
      />
    </g>
  );
};

export default Icon;
